import { render, staticRenderFns } from "./complaintSheetAssess.vue?vue&type=template&id=0b6d3ced&scoped=true"
import script from "./complaintSheetAssess.vue?vue&type=script&lang=js"
export * from "./complaintSheetAssess.vue?vue&type=script&lang=js"
import style0 from "./complaintSheetAssess.vue?vue&type=style&index=0&id=0b6d3ced&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6d3ced",
  null
  
)

export default component.exports